import { Receipt } from '../../../types/receipts';

export enum ActionTypes {
    GetReceipts = '[customer/receipts] GET_RECEIPTS',
    FetchReceiptsResponse = '[customer/receipts] FETCH_RECEIPTS_RESPONSE',
    FetchNextResponse = '[customer/receipts] FETCH_NEXT_RESPONSE',
}

export enum GetReceiptsReason {
    mount = 'mount',
    update = 'update',
    next = 'next',
    refresh = 'refresh',
}

export interface GetReceipts {
    type: ActionTypes.GetReceipts;
    payload: {
        accountId: string;
        id: string;
        params: URLSearchParams;
        requestId: number;
        reason: GetReceiptsReason;
    };
}

export interface FetchReceiptsResponse {
    type: ActionTypes.FetchReceiptsResponse;
    payload: {
        receipts: Receipt[];
        starting_after: string;
    };
    meta: {
        cause: GetReceipts;
    };
}

export interface FetchNextResponse {
    type: ActionTypes.FetchNextResponse;
    payload: {
        receipts: Receipt[];
        starting_after: string;
    };
    meta: {
        cause: FetchReceiptsResponse;
    };
}

export function getReceipts(
    accountId: string,
    id: string,
    params: URLSearchParams,
    reason: GetReceiptsReason
): GetReceipts {
    return {
        type: ActionTypes.GetReceipts,
        payload: {
            accountId,
            id,
            params,
            reason,
            requestId: performance.now(),
        },
    };
}

export type Actions =
    | GetReceipts
    | FetchReceiptsResponse
    | FetchNextResponse;
